import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";

import { SharedModule } from "../../shared/shared.module";
import { TaskOverviewComponent } from "./task-overview.component";
import { TaskListComponent } from "./list/task-list.component";
import { TaskItemComponent } from "./task-item/task-item.component";
import { IndividualPlanComponent } from "./individual-plan/individual-plan.component";
import { TaskSwipeListComponent } from "./task-swipe-list/task-swipe-list.component";
import { ActivityItemComponent } from "./activity-item/activity-item.component";
import { ActivityListComponent } from "./activity-list/activity-list.component";

@NgModule({
	imports: [IonicModule, SharedModule],
	declarations: [
		TaskOverviewComponent,
		TaskListComponent,
		TaskItemComponent,
		IndividualPlanComponent,
		TaskSwipeListComponent,
		ActivityItemComponent,
		ActivityListComponent,
	],
	exports: [TaskOverviewComponent],
})
export class TaskOverviewModule {}
